import { Criterion } from '@/interfaces/criterion';

/**
 * Sortuje kryteria
 *
 * @param {Criterion[]} criterions
 * @returns
 */
export function sortCriterions(criterions: Criterion[]): Criterion[] {
  const rootCriterion = criterions.find(criterion => !criterion.parentId);
  if (rootCriterion) {
    const children = criterions.filter(criterion => criterion.parentId === rootCriterion.id);
    return sortedCriterion([...children, rootCriterion]);
  }
  return [];
}

/**
 * Sortuje gałąź kryteriów
 *
 * @param {Criterion[]} criterions
 * @param {Criterion} parent
 * @returns
 */
export function sortedCriterion(criterions: Criterion[]): Criterion[] {
  return criterions.sort((a, b) => (a.order as number) - (b.order as number) || (a.id as number) - (b.id as number));
}

/**
 * Zwraca kryteria należące do głównego kryterium
 *
 * @export
 * @param {Criterion[]} criterions
 * @param {Criterion} rootCriterion
 * @returns {Criterion[]}
 */
export function groupCriterions(criterions: Criterion[], rootCriterion: Criterion): Criterion[] {
  return sortedCriterion(criterions.filter(criterion => criterion.parentId === rootCriterion.id));
}
